import React, {useState} from 'react';
import CircleYellowPlus from '../../assets/circle_yellow_plus.svg';
import {AddChatParticipantModal} from "../travelClaims/itemComponents/Colleagues";

interface Props {
    trip_id: string
    chat_pk: string
}

export const AddParticipantForm = ({trip_id, chat_pk}: Props) => {
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const openAddModal = () => setIsAddModalOpen(true);
    const closeAddModal = () => setIsAddModalOpen(false);

    return (
        <>
            <AddChatParticipantModal
                claim_pk={trip_id}
                chat_pk={chat_pk}
                isOpen={isAddModalOpen}
                onClose={closeAddModal}/>
            <button
                className='w-10 h-10 flex justify-center items-center'
                onClick={openAddModal}
            >
                <img src={CircleYellowPlus} alt='Add participant'/>
            </button>
        </>
    );
};
